var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { MEDIUM_CLASS } from '../../util/screen';
import Downshift from 'downshift';
var FilterButtonContainer = styled.button((_a = {
        cursor: 'pointer',
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontFamily: 'var(--font-family-primary)',
        lineHeight: 'normal',
        alignContent: 'baseline',
        padding: '15px 18px',
        backgroundColor: '#fff',
        border: 'none',
        width: '100%',
        ':active': {
            backgroundColor: '#dadada',
        }
    },
    _a["&.".concat(MEDIUM_CLASS)] = {
        borderRadius: '4px',
        border: '2px solid #dbdbdb',
        justifyContent: 'center',
    },
    _a));
var FilterButtonIcon = styled.span({
    marginLeft: '11px',
});
var DropdownButton = styled.div({});
var DropdownUl = styled.ul((_b = {
        maxHeight: '500px',
        maxWidth: '320px',
        minWidth: '288px',
        font: '300 14px/1.43 Montserrat, Helvetica, Arial, sans-serif',
        backgroundColor: '#fff',
        padding: '0.5rem 1rem',
        overflowX: 'hidden',
        overflowY: 'auto',
        marginTop: '5px',
        whiteSpace: 'normal'
    },
    _b["&.".concat(MEDIUM_CLASS)] = {
        position: 'absolute',
        boxShadow: '12px 13px 22px 0 rgba(0, 0, 0, 0.2)',
        borderRadius: '4px',
        border: '2px solid #d6d6d6',
    },
    _b));
var DropdownLi = styled.li({
    padding: 0,
    margin: 0,
    listStyle: 'none',
    marginRight: '0.375rem',
    marginTop: '0.5rem',
    cursor: 'pointer',
    minHeight: '28px',
    position: 'relative',
});
var DropdownLiContent = styled.div((_c = {
        margin: 0,
        padding: 0,
        display: 'inline'
    },
    _c["&.".concat(MEDIUM_CLASS)] = {
        borderBottom: 'none',
    },
    _c));
var DropdownLiCheckbox = styled.input({
    opacity: 0,
    verticalAlign: 'middle',
    width: '24px',
    height: '24px',
    padding: 0,
    margin: 0,
});
var DropdownLiLabel = styled.label({
    verticalAlign: 'text-top',
    marginLeft: '12px',
    cursor: 'pointer',
    '&::before': {
        position: 'absolute',
        left: 0,
        top: '50%',
        transform: 'translate(0, -50%)',
        content: '""',
        height: '24px',
        width: '24px',
        border: '2px solid #595959',
        borderRadius: '2px',
        background: '#fff',
    },
    '&.selected:after': {
        content: '""',
        color: '#595959',
        position: 'absolute',
        left: '6px',
        top: 'calc(50% - 6px)',
        display: 'inline-block',
        height: '6px',
        width: '14px',
        borderLeft: '2px solid',
        borderBottom: '2px solid',
        transform: 'rotate(-45deg)',
    },
});
var FilterButton = function (_a) {
    var icon = _a.icon, onClick = _a.onClick, label = _a.label, className = _a.className;
    return (_jsxs(FilterButtonContainer, __assign({ onClick: onClick, className: className }, { children: [_jsx("span", { children: label }, void 0), icon ? _jsx(FilterButtonIcon, { children: icon }, void 0) : null] }), void 0));
};
export var FiltersSelect = function (_a) {
    var filter = _a.filter, value = _a.value, onChange = _a.onChange, isOpen = _a.isOpen, onShow = _a.onShow, onHide = _a.onHide, Icon = _a.Icon, className = _a.className;
    var options = useMemo(function () { return filter.options.slice().sort(function (a, b) { return a.name.localeCompare(b.name); }); }, [filter.options]);
    var onButtonClick = useCallback(function () {
        if (isOpen) {
            onHide(filter.id);
        }
        else {
            onShow(filter.id);
        }
    }, [onShow, onHide, filter.id, isOpen]);
    var onOptionChange = useCallback(function (selectedOption) {
        if (!selectedOption)
            return;
        if (value.some(function (option) { return option.id === selectedOption.id; })) {
            onChange(value.filter(function (option) { return option.id !== selectedOption.id; }));
        }
        else {
            onChange(value.concat(selectedOption));
        }
    }, [onChange, value]);
    var handleOuterClick = useCallback(function () {
        onHide(filter.id);
    }, [onHide, filter.id]);
    var getListItems = useCallback(function (_a) {
        var getItemProps = _a.getItemProps, highlightedIndex = _a.highlightedIndex;
        return options.map(function (item, index) {
            var itemIsSelected = value.some(function (o) { return o.id === item.id; });
            return (_jsx(DropdownLi, __assign({ className: className }, getItemProps({
                key: item.id,
                index: index,
                item: item,
                style: {
                    backgroundColor: highlightedIndex === index ? 'lightgray' : undefined,
                    fontWeight: itemIsSelected ? 'bold' : 'normal',
                },
            }), { children: _jsxs(DropdownLiContent, __assign({ className: className }, { children: [_jsx(DropdownLiCheckbox, { name: item.slug, type: "checkbox", checked: itemIsSelected, readOnly: true }, void 0), _jsxs(DropdownLiLabel, __assign({ htmlFor: item.slug, className: itemIsSelected ? 'selected' : '' }, { children: [item.name, " (", item.publishedRecipesCount, ")"] }), void 0)] }), void 0) }), item.id));
        });
    }, [options, value, className]);
    return (_jsx(Downshift, __assign({ isOpen: isOpen, onOuterClick: handleOuterClick, onSelect: onOptionChange, itemToString: function (item) { var _a; return (_a = item === null || item === void 0 ? void 0 : item.name) !== null && _a !== void 0 ? _a : ''; } }, { children: function (_a) {
            var getRootProps = _a.getRootProps, getItemProps = _a.getItemProps, getMenuProps = _a.getMenuProps, isOpen = _a.isOpen, highlightedIndex = _a.highlightedIndex;
            return (_jsxs(DropdownButton, __assign({}, getRootProps(), { children: [_jsx(FilterButton, { onClick: onButtonClick, label: filter.label, icon: Icon, className: className }, void 0), isOpen ? (_jsx(DropdownUl, __assign({ className: className }, getMenuProps(), { children: getListItems({ getItemProps: getItemProps, highlightedIndex: highlightedIndex }) }), void 0)) : null] }), void 0));
        } }), void 0));
};
